import React from "react";
import { RouteComponentProps } from "react-router";
import { store } from "@store";
import AccommodationSearch from "./AccommodationSearch/AccommodationSearch";
import {
  ACCOMMODATION_SLIDER,
  AccommodationEditorLocation,
  AccommodationProfileLocation
} from "@navigation/locations";
import { checkIfDirectRoute } from "@utils/navigationUtils";

type Props = RouteComponentProps<any>;

export function AccommodationSearchPage(props: Props) {
  const { match } = props;
  const { url } = match;

  const { navigation } = store();

  return (
    <>
      {catchDirectUrl(url)}
      <AccommodationSearch
        onOpen={(id) => {
          navigation.open(ACCOMMODATION_SLIDER, new AccommodationProfileLocation(id));
        }}
        onNewItem={() => {
          navigation.open(ACCOMMODATION_SLIDER, new AccommodationEditorLocation(null));
        }}
      />
    </>
  );
}

function catchDirectUrl(url) {
  return checkIfDirectRoute(
    `${url}/:id?/:action?`,
    ACCOMMODATION_SLIDER,
    ({ id, action }) => {
      if (id === "new") {
        return new AccommodationEditorLocation(null);
      }
      if (id) {
        if (action) {
          return new AccommodationEditorLocation(id);
        }
        return new AccommodationProfileLocation(id);
      }
    }
  );
}
